import { SocketMessage } from '../../../common/src/model.ts';
import { isHashesChangedMessage, isUpdateWeeklySongListMessage } from '../../../common/src/model_util.ts';
import { getCurrentOrg, synchronizeWeeklySongLists } from '../data/use_current_org.tsx';
import { scheduleLiveUpdateRefresh, scheduleOrgChangedSync } from './live_update_refresh.ts';

// What the app does with each message the live-update socket delivers (GitHub issue #3265).
export function handleLiveUpdateMessage(message: SocketMessage) {
  // read before the guards below narrow the message away from its own type
  const { type } = message;
  if (isUpdateWeeklySongListMessage(message)) {
    const messageOrgId: number = Number(message.orgId);
    if (messageOrgId === getCurrentOrg()?.id) {
      if (message.orgChanged) {
        // the org itself changed (a church's liturgy schema or singing plan, issue #4213): fetch it within seconds
        // rather than within the hour, so the Church tab, the Today tiles and the lists downloaded next follow the
        // new org. Jittered and coalesced, since the whole church receives it at once and one save can send two
        scheduleOrgChangedSync({ orgId: messageOrgId });
        return;
      }
      void synchronizeWeeklySongLists();
    }
    return;
  }
  if (isHashesChangedMessage(message)) {
    // content-free: the walk asks the server what changed. A ping scoped to orgs (an org hymnal
    // change) is nothing to a client of another org. One song-list save can produce both this
    // message and the one above, which the two coalescers reduce to one sync and one walk.
    const currentOrgId = getCurrentOrg()?.id;
    if (message.orgIds && (currentOrgId === undefined || !message.orgIds.includes(currentOrgId))) {
      return;
    }
    scheduleLiveUpdateRefresh();
    return;
  }
  // an old bundle meeting a newer server's message type is expected during a rollout, not an error
  console.log(`ignoring unrecognized live-update message type: ${type}`);
}
